import { BrandfolderHexColors } from '../enums/colors.js';

const defaultSwitchLight = {
    backgroundColor: '#dcdee5',
    backgroundColorChecked: BrandfolderHexColors.PurplePopsicle,
    backgroundColorDisabled: '#dcdee5',
    outlineColorFocus: '#1895F5',
    switchBackgroundColor: BrandfolderHexColors.White,
    switchBackgroundColorChecked: BrandfolderHexColors.White,
    switchBackgroundColorDisabled: '#dcdee5',
    switchBorderColor: '#c1c4cf',
    switchBorderColorChecked: BrandfolderHexColors.PurplePopsicle,
    switchBorderColorDisabled: '#c1c4cf'
};

export { defaultSwitchLight };
//# sourceMappingURL=switch.js.map
